import React from "react";
import { Gauge, CheckCircle2, CalendarClock, AlertOctagon, ClipboardList } from "lucide-react";

function Card({ icon: Icon, label, headline, sub, tone = "sky", testid }) {
  const t = ({
    sky:     { rail: "before:bg-sky-500",     iconBg: "bg-sky-50 border-sky-100", iconText: "text-sky-700" },
    emerald: { rail: "before:bg-emerald-500", iconBg: "bg-emerald-50 border-emerald-100", iconText: "text-emerald-700" },
    amber:   { rail: "before:bg-amber-500",   iconBg: "bg-amber-50 border-amber-100", iconText: "text-amber-700" },
    red:     { rail: "before:bg-red-500",     iconBg: "bg-red-50 border-red-100", iconText: "text-red-700" },
    violet:  { rail: "before:bg-violet-500",  iconBg: "bg-violet-50 border-violet-100", iconText: "text-violet-700" },
  })[tone] || {};
  return (
    <div data-testid={testid} className={`relative pl-4 pr-4 py-3.5 bg-white border border-slate-200 rounded-lg shadow-sm before:absolute before:left-0 before:top-0 before:bottom-0 before:w-1 before:rounded-l-lg ${t.rail}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.14em] font-semibold text-slate-500">{label}</div>
          <div className="mt-1 font-heading text-2xl font-semibold text-slate-900 tabular-nums">{headline}</div>
          <div className="text-[11px] text-slate-500 mt-0.5 min-h-[16px]">{sub}</div>
        </div>
        <div className={`shrink-0 w-8 h-8 rounded-lg ${t.iconBg} border flex items-center justify-center`}>
          <Icon className={`w-4 h-4 ${t.iconText}`} />
        </div>
      </div>
    </div>
  );
}

export default function AuditSummaryCards({ summary }) {
  const s = summary || {};
  const score = s.overall_score;
  const scoreTone = score == null ? "sky" : score >= 90 ? "emerald" : score >= 70 ? "amber" : "red";
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-3" data-testid="audits-qa-summary">
      <Card icon={Gauge} label="Overall Audit Score" headline={score == null ? "—" : `${score.toFixed(1)}%`}
        sub={s.audits_scored ? `Average across ${s.audits_scored} scored audit${s.audits_scored === 1 ? "" : "s"}` : "No scored audits yet"}
        tone={scoreTone} testid="aq-card-score" />
      <Card icon={CheckCircle2} label="Completed This Month" headline={summary ? `${s.completed_this_month}` : "—"}
        sub="Audits closed since the 1st"
        tone={summary && s.completed_this_month > 0 ? "emerald" : "sky"}
        testid="aq-card-completed" />
      <Card icon={CalendarClock} label="Audits Due" headline={summary ? `${s.due_soon}` : "—"}
        sub="Scheduled within 30 days"
        tone={s.due_soon > 0 ? "amber" : "emerald"} testid="aq-card-due" />
      <Card icon={AlertOctagon} label="Overdue Audits" headline={summary ? `${s.overdue}` : "—"}
        sub="Past their next-due date"
        tone={s.overdue > 0 ? "red" : "emerald"} testid="aq-card-overdue" />
      <Card icon={ClipboardList} label="Open Improvement Actions" headline={summary ? `${s.open_actions}` : "—"}
        sub="Corrective actions still open"
        tone={s.open_actions > 0 ? "amber" : "emerald"} testid="aq-card-actions" />
    </div>
  );
}
